import { Fragment } from "react";
import { useLocation } from "react-router-dom";
import { CircularProgress } from "@mui/material";

import useFetch from "../../hooks/useFetch";
import { EditClientForm } from "./components/EditClientForm";
import { urlEditClients } from "../../helpers";

export const EditClient = () => {

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    
    const { status, data } = useFetch(`${urlEditClients}${searchParams.get('id')}`, 'GET');

  return (
      <Fragment>
          {(status) ? <EditClientForm data={data} /> : <CircularProgress />}
      </Fragment>
  )
}
